/*
 * File: SelectTags.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on April 20, 2025 at 11:54 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 7, 2025 at 12:57 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Components
import { LegalSnippet as LegalSnippetBase } from '../../LegalSnippet';

// Constants
import { ShareBottomPadding, ShareTopbarHeight } from '../../../styles/constants';


/**
 * Styles
 */

export const StepContainer = styled.div`
	width: 100%;
	min-height: calc(100vh - ${ShareTopbarHeight}px - ${ShareBottomPadding}px);
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const InnerStep = styled.div`
	width: 100%;
	max-width: 800px;
	padding: 50px 0px 50px;
`;

export const ContentContainer = styled.div`
	p {
		margin: 10px 0px 0px;
	}
	br {
		margin: 10px;
	}
`;

export const ActionContainer = styled.div`
	margin: 30px 0px 0px;
	display: flex;
	gap: 10px;
`;

export const LegalSnippet = styled(LegalSnippetBase)`
	margin: 30px 0px 0px;
`;

export const TagFamilyContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 35px;
	margin: 30px 0px 0px;
`;

export const TagFamily = styled.div`
	h5 {
		margin: 0px 0px 12px;
	}
`;

export const TagContainer = styled.div`
	display: flex;
	gap: 8px;
	flex-wrap: wrap;

	p {
		text-align: left;
	}
`;

export const SuggestionContainer = styled.div`
	margin: 20px 0px 50px;
`;

export const SuggestionButton = styled.button`
	border: none;
	background-color: transparent;
	font-size: inherit;
	text-decoration: underline;
	cursor: pointer;
`;
